import { useState } from "react";
import type { Bank } from "../api";

type Props = {
  bank: Bank;
  size?: number;
};

/** Logo ngân hàng với fallback chữ khi ảnh lỗi hoặc chưa có field logo. */
export default function BankLogo({ bank, size = 56 }: Props) {
  const [failed, setFailed] = useState(false);
  const showFallback = failed || !bank.logo;

  if (showFallback) {
    const initials = (bank.shortName || bank.code || "??").slice(0, 4);
    return (
      <span
        className="bank-logo bank-logo-fallback"
        style={{ width: size, height: size }}
        aria-hidden="true"
      >
        {initials}
      </span>
    );
  }

  return (
    <img
      className="bank-logo"
      style={{ width: size, height: size }}
      src={bank.logo}
      alt=""
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}
